import type { ImageRecord, UploadDeviceClass } from './imageDb'

export type UploadDeviceInfo = {
    deviceClass: UploadDeviceClass
    deviceOs: string
    deviceBrowser: string
}

function classifyDeviceClass(ua: string) {
    const lower = ua.toLowerCase()
    const hasTouch = typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0
    const isTablet =
        /ipad|tablet|playbook|silk/i.test(ua) ||
        (/android/i.test(ua) && !/mobile/i.test(ua)) ||
        lower.includes('sm-t') ||
        lower.includes('tab')

    if (isTablet) return 'tablet' as const
    if (/mobi|iphone|ipod|android/i.test(ua) || hasTouch && typeof window !== 'undefined' && window.matchMedia?.('(max-width: 820px)')?.matches) {
        return 'mobile' as const
    }
    if (!ua) return 'unknown' as const
    return 'desktop' as const
}

function detectOs(ua: string) {
    if (/android/i.test(ua)) return 'Android'
    if (/iphone|ipad|ipod/i.test(ua)) return 'iOS'
    if (/windows/i.test(ua)) return 'Windows'
    if (/mac os x|macintosh/i.test(ua)) return 'macOS'
    if (/linux/i.test(ua)) return 'Linux'
    if (/cros/i.test(ua)) return 'ChromeOS'
    return 'unknown'
}

function detectBrowser(ua: string) {
    if (/samsungbrowser/i.test(ua)) return 'Samsung Internet'
    if (/edg\//i.test(ua)) return 'Edge'
    if (/firefox|fxios/i.test(ua)) return 'Firefox'
    if (/chrome|crios/i.test(ua) && !/edg\//i.test(ua)) return 'Chrome'
    if (/safari/i.test(ua) && !/chrome|crios|android/i.test(ua)) return 'Safari'
    return 'unknown'
}

export function detectCurrentUploadDeviceInfo(): UploadDeviceInfo {
    const ua = typeof navigator !== 'undefined' ? String(navigator.userAgent || '') : ''
    return {
        deviceClass: classifyDeviceClass(ua),
        deviceOs: detectOs(ua),
        deviceBrowser: detectBrowser(ua),
    }
}

export function resolveUploadDeviceInfo(rec?: ImageRecord | null): UploadDeviceInfo {
    const existing = (rec as any)?.upload || {}
    const deviceClass = String(existing?.deviceClass || '').trim()
    const deviceOs = String(existing?.deviceOs || '').trim()
    const deviceBrowser = String(existing?.deviceBrowser || '').trim()
    if (deviceClass || deviceOs || deviceBrowser) {
        return {
            deviceClass: (deviceClass || 'unknown') as UploadDeviceClass,
            deviceOs: deviceOs || 'unknown',
            deviceBrowser: deviceBrowser || 'unknown',
        }
    }
    return detectCurrentUploadDeviceInfo()
}
